import T from 'i18n-react';
import German from '../languages/de';
import English from '../languages/en';
import Spanish from '../languages/es';
import French from '../languages/fr';
import Italian from '../languages/it';
import Slovak from '../languages/sk';
import Romanian from '../languages/ro';
import Croatian from '../languages/hr';

const getTranslations = (language, source) => {
  switch (language) {
    case 'German':
      return German[source];
    case 'English':
      return English[source];
    case 'Spanish':
      return Spanish[source];
    case 'French':
      return French[source];
    case 'Italian':
      return Italian[source];
    case 'Slovak':
      return Slovak[source];
    case 'Romanian':
      return Romanian[source];
    case 'Croatian':
      return Croatian[source];
    default:
      return English[source];
  }
};

const configureT = (language, source) => {
  T.setTexts(getTranslations(language, source));
};

export default configureT;



// WEBPACK FOOTER //
// ./src/components/configureT.js